import { Extension } from "@tiptap/core"

export const DisableCommandEnter = Extension.create({
	name: "DisableCommandEnter",
	addKeyboardShortcuts: () => ({
		"Cmd-Enter": () => true,
		"Ctrl-Enter": () => true,
	}),
})
